import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { Bitmap as t } from "../../engine/Bitmap.js";
import { BitmapContainer as e } from "../../engine/BitmapContainer.js";

var i = /*#__PURE__*/function (_e) {
  _inherits(i, _e);

  var _super = _createSuper(i);

  function i(e) {
    var _this;

    _classCallCheck(this, i);

    _this = _super.call(this), _this.requestRender = _this.requestRender.bind(_assertThisInitialized(_this)), _this._layerView = e, _this._canvas = document.createElement("canvas"), _this._context = _this._canvas.getContext("2d"), _this._bitmap = new t(null, "standard", !1), _this.addChild(_this._bitmap);
    return _this;
  }

  _createClass(i, [{
    key: "doRender",
    value: function doRender(t) {
      var e = t.state,
          _i = this._createCustomRenderParams(t),
          a = this._canvas,
          s = this._bitmap,
          n = window.devicePixelRatio;

      a.width = e.size[0] * n, a.height = e.size[1] * n, s.resolution = e.resolution;
      var o = e.clone();
      o.pixelRatio = n, s.pixelRatio = n, _i.state = o, s.x = e.viewpoint.targetGeometry.x - Math.abs(e.extent.xmax - e.extent.xmin) / 2, s.y = e.viewpoint.targetGeometry.y + Math.abs(e.extent.ymax - e.extent.ymin) / 2, this._layerView.render(_i), s.source = a, s.rotation = e.rotation, _get(_getPrototypeOf(i.prototype), "doRender", this).call(this, _objectSpread(_objectSpread({}, t), {}, {
        state: o
      }));
    }
  }, {
    key: "_createCustomRenderParams",
    value: function _createCustomRenderParams(t) {
      return {
        globalOpacity: t.globalOpacity,
        state: t.state,
        stationary: t.stationary,
        pixelRatio: window.devicePixelRatio,
        context: this._context
      };
    }
  }]);

  return i;
}(e);

export { i as Display, i as default };